export default {
    namespaced: true,
    state: () => ({
        status: "All",
        search: null,
        extendedFilter: {
            EFTheme: {
                label: "Краткое_содержание",
                value: null
            },
            RegNumber: {
                label: "Рег._номер",
                value: null
            },
            OutNumber: {
                label: "Исходящий_номер",
                value: null
            },
            HigherNumber: {
                label: "Номер_вышестоящего_корреспондента",
                value: null
            },
            Correspondent: {
                label: "Корреспондент",
                value: []
            },
            ExecuterName: {
                label: "Исполнитель",
                value: null
            },
            JuridicalDocType: {
                label: "Тип_документа",
                value: null
            },
            SignerName: {
                label: "Подписал",
                value: null
            },
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            Recipients: {
                label: "Получатель",
                value: []
            },
            OutDateFrom: {
                label: "Дата_исходящего_c",
                value: null
            },
            OutDateTo: {
                label: "Дата_исходящего_по",
                value: null
            },
            Language: {
                label: "Язык_документа",
                value: null
            },
            Executers: {
                label: "Исполнитель",
                value: []
            },
            ResolutionAuthor: {
                label: "Автор_резолюции",
                value: []
            },
            HasAnswer: {
                label: "Дан_ответ",
                value: null
            },
            ExecuteStatus: {
                label: "Статус_исполнения",
                value: []
            },
            IsDuplicate: {
                label: "Дубликат",
                value: null
            },
            IsIncomingAnswer: {
                label: "Входящий_ответ",
                value: null
            },
            Counter: {
                label: "Журнал_регистрации",
                value: null
            },
            NomenclatureId: {
                label: "Номенклатура",
                value: []
            },
        },
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
            state.tableOptions.page = 1;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
            state.tableOptions.page = 1;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
            state.tableOptions.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getStatus: (s) => s.status,
        getSearch: (s) => s.search,
        getExtendedFilter: (s) => s.extendedFilter,
    }
}